/**
 * Normaliza paths internos para uma única forma indexável: sem barra final,
 * exceto na página inicial. Também remove query strings e hashes do canonical.
 */
export function canonicalPath(path: string): string {
  const pathname = path.split(/[?#]/, 1)[0].replace(/\/{2,}/g, "/");
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "") || "/";
}
